import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";

/**
 * @class CreditCardPaymentOption
 * @property {integer} id
 * @property {Property} property
 * @property {integer} allow_direct_reservations
 * @property {integer} allow_booking_engine
 * @property {integer} suggest_store_cc_info
 * @property {integer} require_ba_booking_using_engine
 * @property {integer} require_ba_reservation_within_app
 * @property {integer} require_ba_payment_existing_reservation
 * @property {integer} field_billing_full_name_display
 * @property {integer} field_billing_full_name_require
 * @property {integer} field_billing_company_display
 * @property {integer} field_billing_company_require
 * @property {integer} field_billing_email_display
 * @property {integer} field_billing_email_require
 * @property {integer} field_billing_phone_display
 * @property {integer} field_billing_phone_require
 * @property {integer} field_billing_country_display
 * @property {integer} field_billing_country_require
 * @property {integer} field_billing_address_display
 * @property {integer} field_billing_address_require
 * @property {integer} field_billing_city_display
 * @property {integer} field_billing_city_require
 */
export class CreditCardPaymentOption extends TranslatableModel {
    
    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }
}

AccessorsMutatorsDecorator('id', 'property', 'property_id', 'allow_direct_reservations', 'allow_booking_engine', 'suggest_store_cc_info', 'require_ba_booking_using_engine', 'require_ba_reservation_within_app',
                           'require_ba_payment_existing_reservation', 'field_billing_full_name_display', 'field_billing_full_name_require', 'field_billing_company_display', 'field_billing_company_require',
                           'field_billing_email_display', 'field_billing_email_require', 'field_billing_phone_display', 'field_billing_phone_require', 'field_billing_country_display', 'field_billing_country_require',
                           'field_billing_address_display', 'field_billing_address_require', 'field_billing_city_display', 'field_billing_city_require')(CreditCardPaymentOption);


// WEBPACK FOOTER //
// ./src/pms-api/models/credit-card-payment-option.model.js